import { render } from "./SongTab.vue?vue&type=template&id=f1917e30&scoped=true"
import script from "./SongTab.vue?vue&type=script&lang=js"
export * from "./SongTab.vue?vue&type=script&lang=js"

import "./SongTab.vue?vue&type=style&index=0&id=f1917e30&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1917e30"]])

export default __exports__